import { render, staticRenderFns } from "./NavBarChamp.vue?vue&type=template&id=0d5abfea"
import script from "./NavBarChamp.vue?vue&type=script&lang=js"
export * from "./NavBarChamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports